import React, { useState } from "react";
import { ReactComponent as WorkIcon } from "../../assets/Experience/work.svg";
import { ReactComponent as SchoolIcon } from "../../assets/Experience/school.svg";

import timelineElements from "./timeLineElements";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./styles/TimeLine.css"; 

const TimeLine = () => {
  const [expandedElements, setExpandedElements] = useState([]);

  const toggleExpand = (id) => {
    if (expandedElements.includes(id)) {
      setExpandedElements(expandedElements.filter((e) => e !== id));
    } else {
      setExpandedElements([...expandedElements, id]);
    }
  };

  return (
    <div className="timeline">
      <VerticalTimeline animate= {true} lineColor= { "white" }>
        {timelineElements.map((element) => {
          const isWorkIcon = element.icon === "work";
          const isExpanded = expandedElements.includes(element.id);

          return (
            <VerticalTimelineElement
              key={element.id}
              date={element.date}
              dateClassName="date"
              iconStyle={isWorkIcon ? { background: "#06D6A0" } : { background: "#f9c74f" }}
              icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />}
            >
              <h3 className="vertical-timeline-element-title">
                {element.title}
              </h3>
              <h5 className="vertical-timeline-element-subtitle">
                {element.location}
              </h5>
              {!isExpanded && (
                <div className="description">
                  <p>{element.description[0]}</p>
                  {element.description.length > 1 && (
                    <button
                      className={`expand-button ${isWorkIcon ? "workButton" : "schoolButton"}`}
                      onClick={() => toggleExpand(element.id)}
                    >
                      Read More
                    </button>
                  )}
                </div>
              )}
              {isExpanded && (
                <div className="expanded-description">
                  {element.description.map((point, index) => (
                    <p key={index}>{point}</p>
                  ))}
                  <button
                    className={`expand-button ${isWorkIcon ? "workButton" : "schoolButton"}`}
                    onClick={() => toggleExpand(element.id)}
                  >
                    Show Less
                  </button>
                </div>
              )}
              {element.buttonText && (
                <a
                  className={`button ${isWorkIcon ? "workButton" : "schoolButton"}`}
                  href="/"
                >
                  {element.buttonText}
                </a>
              )}
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
};

export default TimeLine;
